<template>
    <v-navigation-drawer
            id="core-navigation-drawer"
            v-model="drawer"
            :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
            :expand-on-hover="expandOnHover"
            src="../../../../assets/daisies.jpg"
            mobile-breakpoint="960"
            app
            width="260"
            v-bind="$attrs"
    >
        <template v-slot:img="props">
            <v-img
                    :gradient="`to bottom, ${barColor}`"
                    v-bind="props"
            />
        </template>

        <v-divider class="mb-1"/>

        <v-list
                dense
                nav
        >
            <v-list-item>

                <v-list-item-content>
                    <img src="../../../../assets/imparfaite-white-logo.svg" alt="Imparfaite." height="30"/>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <v-divider class="mb-2"/>

        <v-list
                expand
                nav
        >
            <!-- Style cascading bug  -->
            <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
            <div/>

            <template v-for="(item, i) in items">
                <base-item
                        v-if="hasRole(item.roles)"
                        :key="`item-${i}`"
                        :item="item"
                />
            </template>

            <!-- Style cascading bug  -->
            <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
            <div/>
        </v-list>

        <template v-slot:append>
            <base-item
                    :item="{
          title: $t('menu.logout'),
          icon: 'power_settings_new',
          onClick:logout
        }"
            />
        </template>
    </v-navigation-drawer>
</template>

<script>
    // Utilities
    import {mapState} from 'vuex'

    export default {
        name: 'DashboardCoreDrawer',

        props: {
            expandOnHover: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                items: [],
            };
        },
        mounted: function () {
            this.items = [
                {
                    icon: 'mdi-view-dashboard',
                    title: this.$i18n.t('menu.dashboard'),
                    to: '/',
                    roles: ['ROLE_ADMINISTRATOR', 'ROLE_STORE_SELLER']
                },
                {
                    icon: 'mdi-store',
                    title: this.$i18n.t('menu.stores'),
                    to: '/admin/stores',
                    roles: ['ROLE_ADMINISTRATOR']
                },
                {
                    icon: 'mdi-tag',
                    title: this.$i18n.t('menu.my_pieces'),
                    to: '/products',
                    roles: ['ROLE_ADMINISTRATOR'],
                },
                // {
                //     title: this.$i18n.t('menu.operation_archives'),
                //     icon: 'mdi-sale',
                //     to: '/operation-archive',
                //     roles: ['ROLE_ADMINISTRATOR', 'ROLE_STORE_SELLER']
                // },
                {
                    icon: 'mdi-tag',
                    title: this.$i18n.t('menu.my_pieces'),
                    roles: ['ROLE_STORE_SELLER'],
                },
                {
                    title: this.$i18n.t('menu.my_pieces_for_sale'),
                    to: '/products?status[]=AVAILABLE_FOR_SALE&status[]=HIDDEN_FOR_SALE',
                    roles: ['ROLE_ADMINISTRATOR', 'ROLE_STORE_SELLER']
                },
                {
                    title: this.$i18n.t('menu.my_pieces_sold'),
                    to: '/products?status[]=SOLD&status[]=RETURNED',
                    roles: ['ROLE_ADMINISTRATOR', 'ROLE_STORE_SELLER']
                },
                {
                    title: this.$i18n.t('menu.my_pieces_rejected'),
                    to: '/products?status=REJECTED',
                    roles: ['ROLE_ADMINISTRATOR', 'ROLE_STORE_SELLER']
                },
                {
                    title: this.$i18n.t('menu.my_pieces_pending'),
                    to: '/products?status[]=PENDING_REVIEW&status[]=ACCEPTED',
                    roles: ['ROLE_ADMINISTRATOR', 'ROLE_STORE_SELLER']
                },
                {
                    type: 'label',
                    title: this.$i18n.t('menu.add_pieces'),
                    to: '/products/new',
                    roles: ['ROLE_STORE_SELLER']
                },
                {
                    icon: 'mdi-package',
                    title: this.$i18n.t('menu.orders'),
                    roles: ['ROLE_STORE_SELLER']
                },
                {
                    icon: 'mdi-wallet',
                    title: this.$i18n.t('menu.orders'),
                    to: '/orders/',
                    roles: ['ROLE_ADMINISTRATOR']
                },
                {
                    title: this.$i18n.t('menu.orders_coming'),
                    to: '/orders/?status[]=PENDING_DELIVERY&status[]=PENDING_CUSTOMER_ACCEPTANCE&status[]=AVAILABLE_FOR_TRANSFER',
                    roles: ['ROLE_ADMINISTRATOR', 'ROLE_STORE_SELLER']
                },
                {
                    title: this.$i18n.t('menu.orders_available'),
                    to: '/orders/?status[]=TRANSFERRED',
                    roles: ['ROLE_ADMINISTRATOR', 'ROLE_STORE_SELLER']
                },
                {
                    title: this.$i18n.t('menu.orders_paid'),
                    to: '/orders/?status[]=PAID&status[]=PENDING_PAYOUT',
                    roles: ['ROLE_ADMINISTRATOR', 'ROLE_STORE_SELLER']
                },
                {
                    icon: 'mdi-truck-delivery',
                    title: this.$i18n.t('menu.shipments'),
                    to: '/shipments',
                    roles: ['ROLE_ADMINISTRATOR']
                },
                {
                    icon: 'mdi-truck-delivery',
                    title: this.$i18n.t('menu.shipments'),
                    roles: ['ROLE_STORE_SELLER']
                },
                {
                    title: this.$i18n.t('menu.shipments_to_imparfaite'),
                    to: '/shipments?kind=FROM_STORE_TO_IMPARFAITE&status[]=PENDING_DEPOSIT&status[]=AWAITING_LABEL_GENERATION',
                    roles: ['ROLE_STORE_SELLER']
                },
                {
                    title: this.$i18n.t('menu.shipments_to_customer'),
                    to: '/shipments?kind=FROM_STORE_TO_CUSTOMER&status[]=PENDING_DEPOSIT&status[]=AWAITING_LABEL_GENERATION',
                    roles: ['ROLE_STORE_SELLER']
                },
                {
                    title: this.$i18n.t('menu.shipments_archived'),
                    to: '/shipments?status[]=TAKEN_IN_CHARGE&status[]=IN_TRANSIT&status[]=IN_TROUBLE',
                    roles: ['ROLE_STORE_SELLER']
                },
                {
                    icon: 'mdi-package-variant',
                    title: this.$i18n.t('menu.detailedOrders'),
                    to: '/detailed_orders',
                    roles: ['ROLE_ADMINISTRATOR']
                },
            ];
        },
        computed: {
            ...mapState(['barColor', 'userInformation']),
            drawer: {
                get() {
                    return this.$store.state.drawer
                },
                set(val) {
                    this.$store.commit('SET_DRAWER', val)
                },
            },
            profile() {
                return {
                    avatar: true,
                    title: 'avatar',
                }
            },
        },

        methods: {
            hasRole(roles) {
                return roles.filter(value => this.userInformation.roles.includes(value)).length;
            },
            logout() {
                this.$store.commit('logout');
                this.$router.push({name: 'Login'});
                window.localStorage.removeItem('jwt')
            }
        },
    }
</script>

<style lang="sass">
    @import '~vuetify/src/styles/tools/_rtl.sass'

    #core-navigation-drawer
        .v-list-item
            min-height: initial
            &__icon--text,
            &__icon:first-child
                justify-content: center
                text-align: center
                width: 20px

                +ltr()
                    margin-right: 24px
                    margin-left: 12px !important

                +rtl()
                    margin-left: 24px
                    margin-right: 12px !important

            &.v-list-item--active
                background: transparent !important
            .v-list-item__content
                padding: 6px 0
        .v-list--dense
            .v-list-item
                &__icon--text,
                &__icon:first-child
                    margin-top: 10px

        .v-list-group--sub-group
            .v-list-item
                +ltr()
                    padding-left: 8px

                +rtl()
                    padding-right: 8px

            .v-list-group__header
                +ltr()
                    padding-right: 0

                +rtl()
                    padding-right: 0

                .v-list-item__icon--text
                    margin-top: 19px
                    order: 0

                .v-list-group__header__prepend-icon
                    order: 2

                    +ltr()
                        margin-right: 8px

                    +rtl()
                        margin-left: 8px
</style>
